"use client";

import React from "react";
import { useApp } from "@/forApp/states/appState/appState";
import type { BaseEntityT } from "@/forApp/types/Entity";
import fetcher from "@/forApp/utils/fetcher/fetcher";
import Button from "@/shared/Buttons/Button";
import Modal from "@/shared/Modal/Modal";
import styles from "./styles.module.css";

interface DeleteObjectModalProps {
	object: BaseEntityT;
	mutate: () => void;
}

const DeleteObjectModal: React.FC<DeleteObjectModalProps> = ({
	object,
	mutate,
}) => {
	const { delModal, addNotification } = useApp();
	const [isLoading, setIsLoading] = React.useState(false);

	const deletePromo = async () => {
		setIsLoading(true);
		try {
			await fetcher("DELETE", `/personal/entities/${object.slug}/force`);
			addNotification({ text: "Объявление успешно удалено", type: "success" });
			mutate();
			delModal();
		} catch (error) {
			console.error("Error deleting object:", error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleCancel = () => {
		delModal();
	};

	return (
		<Modal title="Удаление объекта">
			<div className={styles.modalContent}>
				<p className={styles.message}>
					Вы уверены что хотите удалить объект{" "}
					<span className={styles.objectName}>{object.full_address}</span>?
				</p>

				<div className={styles.buttonsContainer}>
					<Button
						text={isLoading ? "Удаление..." : "Да"}
						color="red"
						onClick={deletePromo}
						isLoading={isLoading}
					/>
					<Button
						text="Нет"
						color="gray"
						onClick={handleCancel}
						disabled={isLoading}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default DeleteObjectModal;
